import React, { PureComponent } from "react";

import { leaderboardAndHealthSortOptions, downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import html2canvas from "html2canvas";
import NoData from "../NoData/NoData";
import LeaderboardHealthCharts from "./LeaderboardHealthCharts";
import CustomDropdown from "../ChartsOptionsSidebar/CustomDropdown";

import { Scrollbars } from "react-custom-scrollbars";

import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import "./LeaderboardHealth.scss";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class LeaderboardHealth extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            groupByTopics: false,
        };
        this.chartEl = React.createRef();
        this.chartComponent = React.createRef();
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "leaderboardAndHealth");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        // let tpc = this.props.allTopics.find(t => t.subtopic_id == stbId)
        // newFilter.subtopics = this.props.groupByTopics ? d.boolean : [d.boolean];
        // newFilter.topics = [];
        newFilter.subtopics = !this.props.groupByTopics ? [d.boolean] : [];
        newFilter.topics = this.props.groupByTopics ? [d.boolean] : [];
        newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [
            [
                "Sl no",
                "Topic",
                "Total Reach",
                "Avg Reach",
                "Total Mentions",
                "Avg Mentions",
                "Total Engagement",
                "Avg Engagement",
                "Avg Impact Score",
                "Likes",
                "Comments",
                "Shares",
                "Views",
            ],
        ];
        if (this.props.data.data.data && this.props.data.data.data.length && !this.props.loading) {
            const sortedData = this.props.data.data.data.sort((a, b) => -1 * (a[this.props.sortBy] - b[this.props.sortBy]));
            const top15Data = sortedData.slice(0, 15);
            top15Data.map((d, i) => {
                csvFmt.push([
                    i + 1,
                    d.topic_name,
                    d.total_reach,
                    Math.round(d.avg_reach * 100) / 100,
                    d.total_mentions,
                    Math.round(d.avg_mentions * 100) / 100,
                    d.total_engagement,
                    +d.avg_engagement.toFixed(2),
                    Math.round(d.avg_impact_score * 100) / 100,
                    d.like_count,
                    d.comment_count,
                    d.share_count,
                    d.view_count,
                ]);
            });
        }

        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    handleGroupTopics = () => {
        this.props.fetchDataFromWidget(null, { groupByTopics: !this.props.groupByTopics });
        this.props.handleGroupTopicsChange();
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart shows leaderboard and health data for all sub-topics that you select. If you select Brands as sub-topics, this chart can show how your brand is doing compared to other brands (Share of Voice) in terms of Mentions, Engagement and Reach."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.groupByTopics} label="Group Topics" onClick={this.handleGroupTopics} />}
                        {!nodata && (
                            <CustomDropdown
                                className="leaderboard-sort-by"
                                name="Sort By"
                                isSearchable={true}
                                options={leaderboardAndHealthSortOptions}
                                value={this.props.leaderBoardSortBy}
                                onChange={this.props.changeLeaderBoardSortOption}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate leaderboard-chart">
                        <Scrollbars autoHide>
                            <div className="leaderboard-chart-items skiptranslate" ref={this.chartEl}>
                                <LeaderboardHealthCharts
                                    data={this.props.data}
                                    sortBy={this.props.leaderBoardSortBy}
                                    groupByTopics={this.props.groupByTopics}
                                    addContextMenuListener={this.addContextMenuListener}
                                />
                            </div>
                        </Scrollbars>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardHealth);
